<template>
	<div>
		<div class="relate-item-group">
			<div class="mr-2 relate-item" v-for="(item,index) in myValue" :key="index">
				{{item}}
				<span class="float-right text-muted">
					<span @click="handlerReOrder(index,-1)" class="op-btn el-icon-arrow-up" v-if="index>0"></span>
					<span
						@click="handlerReOrder(index,1)"
						class="op-btn el-icon-arrow-down"
						v-if="index<myValue.length-1"
					></span>
					<span @click="handleClose(index)" class="op-btn">
						<span class="el-icon-close"></span>
					</span>
				</span>
			</div>
		</div>
		<hr />
		<div class="d-flex">
			<label class="mr-3">
				添加
				<input v-model="tmpNew" class="form-control" @keyup.enter="handleAddNew" />
			</label>
			<span @click="handleAddNew()" class="op-btn">
				<span class="el-icon-plus"></span>
			</span>
		</div>
	</div>
</template>
<script>
import RelateInput from "@/mixins/RelateInput.js";

export default {
	mixins: [RelateInput],

	data() {
		return {
			id: "",
			loading: false,
			isMulti: true,
			tmpNew: "",
			myCheckValue: [],
		};
	},
	props: {
		dataModelName: {
			type: String,
			default: "",
		},
		nameFields: {
			type: Array,
			default: () => {
				return ["name"];
			},
		},
		value: {
			type: Array,
			default: () => {
				return [];
			},
		},
		params: {
			type: Object,
			default: function() {
				return {
					allowCreate: true,
					isCheckbox: false,
				};
			},
		},
	},
	created() {},
	mounted() {},
	watch: {
		dataModelName: {
			handler(val) {
				this.dataModel = this.dataModelName;
			},
			immediate: true,
		},
	},
	methods: {
		handleClose(index) {
			this.myValue.splice(index, 1);
		},
		handlerReOrder(index, direction) {
			if (direction == -1 && index == 0) {
				return;
			}
			if (direction == 1 && index == this.myValue.length - 1) {
				return;
			}
			let tempOption = this.myValue[index + direction];
			this.$set(this.myValue, index + direction, this.myValue[index]);
			this.$set(this.myValue, index, tempOption);
		},
		resetEditor(val) {
			this.myValue = [];
			if (!val) {
				return;
			}
			for (let i = 0; i < val.length; i++) {
				this.myValue.push(val[i]);
			}
		},
		calcName(item) {
			let names = [];
			for (let k in this.nameFields) {
				names.push(item[this.nameFields[k]]);
			}
			return names.join(" / ");
		},
		handleAddNew() {
			let index = this.myValue.findIndex(val => {
				return val == this.tmpNew;
			});
			if (index == -1) {
				this.myValue.push("" + this.tmpNew);
				this.$emit("input", this.myValue);
				this.$emit("change", this.myValue);
			} else {
				this.$message.warning("数据重复");
			}
			this.tmpNew = "";
		},
	},
	components: {},
};
</script>
